export default "__VITE_ASSET__CnoY2URW__"